import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Table from 'react-bootstrap/Table'
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select"
import { saveVendorForm1 } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchKDSVendor } from "assets/globalAPI/apiGlobal";
import {Dialog, DialogContent,DialogActions, DialogTitle,TextareaAutosize} from '@mui/material'
import { updateVendorMDM } from "assets/globalAPI/apiGlobal";
import { syncVendorMDM } from "assets/globalAPI/apiGlobal";


const VendorForm3=()=>{
    const navigate= useNavigate();
    const [loaderspinner, setLoaderSpinner] = useState(false);
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const [isActive,setIsActive]= useState(false)
    const [stateSelected,setStateSelected]= useState(false)
    const [titleSelected,setTitleSelected]= useState(false)
    const [dialogOpen,setDialogOpen]= useState(false)
    const [dialogOpen2,setDialogOpen2]= useState(false)
    const [openComment,setOpenComment]= useState(false)
    const [searchLoader,setSearchLoader]= useState(false)
    const [searchTerm,setSearchTerm]= useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const toastId = React.useRef(null);
    const [loader, setLoader] = useState(false);
    const [formSubmitted, setIsFormSubmiteed] = useState(false);
    const [panGSTError, setPanGSTError] = useState(false);
    const [panGSTError2, setPanGSTError2] = useState(false);
    const contactEmail= localStorage.getItem("contactPersonEmail")
    const contactMobile= localStorage.getItem("contactPersonMobile")
    const refId= localStorage.getItem("refId");
    const [selectedState,setSelectedState]= useState("");
    const [indexSelected,setIndexSelected]= useState("");
    const [selectedField, setSelectedField] = useState("");
    const [keySelected,setKeySelected]= useState('');
    const [selectedTitle,setSelectedTitle]= useState("");
    const [userID,setUserID]=useState("");
     const [kdsdata,setKdsData]=useState({});
     const [vendorState,setVendorState]=useState([]);
    const [refID, setRefID] = useState(localStorage.getItem("refId") || ""); 
    // console.log("refId>> ", refId)
    const refType= localStorage.getItem("refType")

    const [firmTypes,setFirmTypes]= useState([]);

    const [formValues, setFormValues] = useState({
      reference_id: {value: refID, error: false},
      trade_name: { value: '', error: false }, // Trade Name(as per gst)*
      street: { value: '', error: false }, // Address(to be registered as per GST)*
      house_no: { value: '', error: false }, // House No.
      type_of_firm: { value: '', error: false }, // Type of Firm/Company*
      cin: { value: '', error: false }, // CIN (if applicable)
      mca_roc_status: { value: '', error: false }, // MCA/ROC status (for Co/LLP)
      city: { value: '', error: false }, // City*
      state: { value: '', error: false }, // State*
      pin_code: { value: '', error: false }, // Pin Code*
      website: { value: '', error: false }, // Website
      proprietor_name: { value: '', error: false }, 
      proprietor_email: { value: '' , error: false}, 
      proprietor_mobile: { value: '' , error: false}, 
      pan: { value: '', error: false }, 
      contact_person: { value: '' , error: false}, // Name of Contact Person*
      contact_person_email: { value: contactEmail, error: false }, // Mobile Number*
      contact_person_mobile: { value: contactMobile, error: false },
      contact_telephone: { value: '', error: false },
      nature_of_business: { value: [],error: false }, // Nature of Business*
      business_category: { value: [],error: false }, // Business Category
      tds_exemption: { value: '',error: false }, // TDS Exemption/Lower Deduction
      tds_nature_of_service: { value: '',error: false }, // Nature of Service for TDS
      tds_section: { value: '',error: false }, // TDS to be Deducted u/s,
      msme_registration_status: { value: '',error: false }, // MSME Registration Status.
      msme_registration_no: { value: '',error: false }, // MSME Registration no.
      msme_category: { value: '',error: false }, // MSME Category
      msme_type: { value: '',error: false }, // MSME Type
      fssai_registration_status: { value: '',error: false }, // FSSI Registration Status.
      fssai_regn_no: { value: '',error: false }, // FSSI Regn No
      fssai_valid_till: { value: '',error: false }, // FSSI Valid Till (dd-mm-yyyy)
      gstn: { value: '',error: false }, // GSTN No*.
      tan: { value: '',error: false }, // TAN*
      itr_filing_status: { value: '',error: false }, // Status of filing ITR of last 2 yrs.
      pan_linked_aadhaar: { value: '',error: false }, // PAN linked with Aadhaar
      gst_turnover_prev_yr: { value: '',error: false }, // GST Turnover of Prev Yr.(Lakhs).
      // prev_yr: { value: '',error: false }, // Prev Yr
      e_invoice_applicable: { value: '',error: false }, // E-Invoice Applicable
      bank_name: { value: '',error: false }, // Bank Name.
      ifsc_code: { value: '',error: false }, // IFSC Code
      bank_account_number: { value: '',error: false }, // Bank Account Number
      cheque_number: { value: '',error: false }, // Cheque Number
      cheque_issued_name: { value: '',error: false }, 
      date_of_fillup: { value: '',error: false }, // GSTN Document*
      approval_status: {value: 'pending'},
      search_term_1: {value:'', error:false},
      search_term_2: {value:'', error:false},
      bp_grouping: {value:'', error:false},
      language: {value: 'EN', error: false},
      telephone: {value: '', error: false},
      cst_no: {value: '', error: false},
      lst_no: {value: '', error: false},
      contact_allowance: {value:'', error:false},
      district: {value:'', error:false},
      po_box: {value:'', error:false},
      region: {value:'', error:false},
      company_code: {value:'', error:false},
      co_name: {value:'', error:false},
      reconciliation_account: {value: '', error: false},
      sort_key: {value: '001', error: false},
      payment_terms: {value: '', error: false},
      payment_methods: {value: '', error: false},
      bank_key: {value: '', error: false},
      account_holder_name: {value: '', error: false},
      abc_indicator: {value: '', error: false},
      withholding_subject: {value: '', error: false},
      withholding_subject_2: {value: '', error: false},
      purchase_organization: {value: '', error: false},
      gr_based_invoice_verification: {value: '', error: false},
      service_based_invoice_verification: {value: '', error: false},
      withholding_tax_type: {value: '', error: false},
      withholding_tax_type_2: {value: '', error: false},
      withholding_tax_code: {value: '', error: false},
      withholding_tax_code_2: {value: '', error: false},
      tax_type: {value: '', error: false},
      tax_type_2: {value: '', error: false},
      tax_type_3: {value: '', error: false},
      tax_type_4: {value: '', error: false},
      // tax_type_5: {value: 'IN5', error: false},
      tax_number: {value: '', error: false},
      tax_number_2: {value: '', error: false},
      tax_number_3: {value: '', error: false},
      tax_number_4: {value: '', error: false},
      tax_number_5: {value: '', error: false},
      recipient_type: {value: '', error: false},
      recipient_type_2: {value: '', error: false},
      order_currency: {value: '', error: false},
      vendor_schema: {value: 'Z1', error: false},
      pan_card_submitted: {value: '', error: false},
      food_license_submitted: {value: '', error: false},
      gstin_submitted: {value: '', error: false},
      tds_details: [
        {
          section_code: "",
          exemption_number: "",
          exemption_rate: "",
          exemption_from: "",
          exemption_to: "",
          exemption_reason: "",
          withholding_tax_type_3: "",
          withholding_tax_code_3: "",
          exemp_threshold: "",
          currency: ""
        }
      ]
    });

    console.log("global json>> ", formValues)

    const handleAddRow = () => {
        setFormValues((prev) => ({
          ...prev,
          tds_details: [
            ...prev.tds_details,
            {
              section_code: "",
              exemption_number: "",
              exemption_rate: "",
              exemption_from: "",
              exemption_to: "",
              exemption_reason: "",
              withholding_tax_type_3: "",
              withholding_tax_code_3: "",
              exemp_threshold: "",
              currency: ""
            }
          ]
        }));
      };
      
      const handleRemoveRow = (indexToRemove) => {
        setFormValues((prev) => ({
          ...prev,
          tds_details: prev.tds_details.filter((_, i) => i !== indexToRemove)
        }));
      };

    useEffect(() => {
      if (refID) {
        setFormValues((prevValues) => ({
          ...prevValues,
          reference_id: { value: refID, error: false },
        }));
        console.log("ref id is>> ", refID)
      }
    }, [refID]);

    function formatDate(value) {
      if (!value) return '';
    
      // If value is already in YYYYMMDD format
      if (typeof value === 'string' && value.length === 8 && /^\d{8}$/.test(value)) {
        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const day = value.substring(6, 8);
        return `${year}-${month}-${day}`;
      }
    
      // If value is in YYYY-MM-DD or similar format
      const dateObj = new Date(value);
    
      // If date is valid, format it
      if (!isNaN(dateObj.getTime())) {
        return dateObj.toISOString().split('T')[0];
      }
    
      // If invalid, don't touch it. Let the user keep typing.
      return value;
    }

      useEffect(() => {
                const handler = setTimeout(() => {
                  setSearchLoader(true); // Show loader AFTER 2 sec pause
                  setDebouncedSearch(searchTerm);
              
                  // Simulate async filtering (optional delay or set false immediately after)
                  setTimeout(() => {
                    setSearchLoader(false); // Hide loader after data is "ready"
                  }, 100); // tweak delay if needed
                }, 600); // Wait for user to stop typing
              
                return () => clearTimeout(handler); // Cleanup if typing again
              }, [searchTerm]);
            
    
            const filteredData = kdsdata[keySelected]?.filter(
              (item) =>
                item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
                item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
            );

    useEffect(() => {
      // const isAuthenticate= localStorage.getItem("isAuthenticated");
      // if(!isAuthenticate){
      //   navigate("/vendor/validation");
      // }

      let userDetails= JSON.parse(localStorage.getItem("userdetails"));
      setUserID(userDetails.id);
      
      fetchAllVendorKDS()
      let msme= localStorage.getItem("msme");
      let fssi= localStorage.getItem("fssi");
      setIsMsme(JSON.parse(msme));
      setIsFssi(JSON.parse(fssi));
      let localForm = localStorage.getItem("editFormApprover");
      if (localForm) {
        const parsedForm = JSON.parse(localForm);
        const updatedValues = {};

        updatedValues.approved_by= userDetails.id

       
        Object.keys(formValues).forEach((key) => {
          
         
            if (key === "tds_details") {
              // Directly assign parsedForm.tds_details to formValues.tds_details
              updatedValues[key] = parsedForm.tds_details || formValues[key]; // fallback to original if undefined
            } else if (parsedForm.hasOwnProperty(key)) {
              updatedValues[key] = {
                ...formValues[key],
                value: parsedForm[key] || '' // in case it's undefined or null
              };
            } else {
              updatedValues[key] = formValues[key]; // keep original
            }
            
          });

          Object.keys(formValues).forEach((key) => {
            let parsedValue = parsedForm[key] || '';
          
            if (["nature_of_business", "business_category"].includes(key)) {
              parsedValue = typeof parsedValue === "string"
                ? parsedValue.trim() === ''
                  ? []
                  : parsedValue.split(",").map(v => v.trim())
                : parsedValue;
          
              updatedValues[key] = {
                ...formValues[key],
                value: parsedValue
              };
          
              console.log("here is updated business value>>> ", parsedValue);
            }
          });
          
    
        setFormValues(updatedValues);
        console.log("Filtered and updated form >>>", updatedValues);
      }
    },[]);


    const handleDropdownClick = (keyName,field) => {
        setKeySelected(keyName);
        setSelectedField(field)
        setDialogOpen(true);      // Open the dialog
      };
    const handleDropdownClick2 = (keyName,field,index) => {
  setKeySelected(keyName);
  setIndexSelected(index);
  setSelectedField(field)
  setDialogOpen2(true); 
};

    const handleFormChange = (field, value,rowIndex=null) => {
      let updatedValue = value;
  
      // Check if the field is one of the multi-selects
      if (field === "nature_of_business" || field === "business_category") {
          // For multi-select fields, we need to extract the 'value' from the selected options array
          updatedValue = value.map(option => option.value).filter(v => v);

          setFormValues((prevState) => ({
            ...prevState,
            approved_by: userID
        }));


      }

      if (field === "purchase_organization") {
        setFormValues(prevState => {
            const currentValues = prevState.purchase_organization.value
                ? prevState.purchase_organization.value.split(",")
                : [];
  
            let newValues = [];
  
            if (value === "") {
                newValues = []; // if blank, clear everything
            } else {
                const isAlreadySelected = currentValues.includes(value);
                newValues = isAlreadySelected
                    ? currentValues.filter(v => v !== value)
                    : [...currentValues, value];
            }
  
            const updatedForm = {
                ...prevState,
                purchase_organization: {
                    ...prevState.purchase_organization,
                    value: newValues.join(","),
                },
                reference_id: {
                    ...prevState.reference_id,
                    value: refID || "",
                },
                approved_by: userID
            };
  
            console.log("Updated formValues 👉", updatedForm);
            return updatedForm;
        });
  
        setSearchTerm("");
        setDialogOpen(false);
        return;
    }
  
      if (field === "withholding_tax_type" || field === "withholding_tax_code") {
        const [taxType, taxCode] = value.split("#"); // Split the value by hash (#)
        
        setFormValues((prevState) => ({
            ...prevState,
            withholding_tax_type: {
                ...prevState.withholding_tax_type,
                value: taxType || "", // Ensure taxType is set properly
            },
            withholding_tax_code: {
                ...prevState.withholding_tax_code,
                value: taxCode || "", // Ensure taxCode is set properly
            },
            reference_id: {
                ...prevState.reference_id,
                value: refID || "", // Ensure refID is always set
            },
            approved_by: userID
        }));
  
        setDialogOpen(false);
        setSearchTerm("");
        return; // Exit early since we handled the split case
    }
  
    if (field === "withholding_tax_type_2") {
      const [taxType, taxCode] = value.split("#"); // Split the value by hash (#)
      
      setFormValues((prevState) => ({
          ...prevState,
          withholding_tax_type_2: {
              ...prevState.withholding_tax_type_2,
              value: taxType || "", // Ensure taxType is set properly
          },
          reference_id: {
              ...prevState.reference_id,
              value: refID || "", // Ensure refID is always set
          },
          approved_by: userID
      }));
  
      setDialogOpen(false);
      setSearchTerm("");
      return; // Exit early since we handled the split case
  }
  
  if (field === "withholding_tax_code_2") {
    const [taxType, taxCode] = value.split("#"); // Split the value by hash (#)
    
    setFormValues((prevState) => ({
        ...prevState,
        withholding_tax_code_2: {
            ...prevState.withholding_tax_code_2,
            value: taxCode || "", // Ensure taxType is set properly
        },
        reference_id: {
            ...prevState.reference_id,
            value: refID || "", // Ensure refID is always set
        },
        approved_by: userID
    }));
  
    setDialogOpen(false);
    setSearchTerm("");
    return; 
  }
  
  if (rowIndex !== null) {
    setFormValues(prevState => {
      const updatedTdsDetails = [...prevState.tds_details];
      updatedTdsDetails[rowIndex][field] = value;
  
      return {
        ...prevState,
        tds_details: updatedTdsDetails,
        reference_id: {
          ...prevState.reference_id,
          value: refID || "",
        },
        approved_by: userID,
      };
    });
    setDialogOpen(false);
    setDialogOpen2(false);
    setSearchTerm("");
    return;
  }
  
      // Update the state for the given field
      setFormValues((prevState) => ({
        ...prevState,
        [field]: {
            ...prevState[field],
            value: updatedValue,
        },
        date_of_fillup:{
          ...prevState.date_of_fillup,
          value: new Date().toISOString().split('T')[0].replaceAll("-", ""),
        },
        approved_by: userID
    }));
    setDialogOpen(false);
    setDialogOpen2(false);
    setSearchTerm("")
  };

   const fetchAllVendorKDS=async()=>{
            try{
              const response= await fetchKDSVendor();
              const res= response.data;
              if(res.status){
                setKdsData(res.data);
                setFirmTypes(res.data.title)
                setVendorState(res.data.region)
                console.log("kds fetched>> ", res.data);
              }else{
                console.log("could not bring material kds>> ", res)
              }
            }catch(error){
              console.log("error bringing material KDS>> ", error);
            }
          }
          const validateTaxFields = () => {
            let isValid = true;
            const updatedForm = { ...formValues };
          
            for (let i = 1; i <= 4; i++) {
              const taxTypeKey = `tax_type${i === 1 ? '' : `_${i}`}`;
              const taxNumberKey = `tax_number${i === 1 ? '' : `_${i}`}`;
          
              const taxTypeVal = formValues[taxTypeKey]?.value?.trim();
              const taxNumberVal = formValues[taxNumberKey]?.value?.trim();
          
              const taxTypeFilled = !!taxTypeVal;
              const taxNumberFilled = !!taxNumberVal;
          
              // If one is filled but the other isn't, mark both with error
              if ((taxTypeFilled && !taxNumberFilled) || (!taxTypeFilled && taxNumberFilled)) {
                if (taxTypeKey in updatedForm) updatedForm[taxTypeKey].error = true;
                if (taxNumberKey in updatedForm) updatedForm[taxNumberKey].error = true;
                isValid = false;
              } else {
                if (taxTypeKey in updatedForm) updatedForm[taxTypeKey].error = false;
                if (taxNumberKey in updatedForm) updatedForm[taxNumberKey].error = false;
              }
            }
          
            setFormValues(updatedForm);
            return isValid;
          };

          const filterEmptyValues = (values) => {
            return Object.fromEntries(
              Object.entries(values).filter(([key, obj]) => {
                if (Array.isArray(obj.value)) {
                  return obj.value.length > 0; // Remove if empty array
                }
                return obj.value !== ''; // Remove if empty string
              })
            );
          };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setIsActive(true);

     if (!validateTaxFields()){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.warning("Please fill the necessary tax fields",{
                      className: "small-toast"
                    })
          }
          setIsActive(false)
          return;
        }
  
    const requiredFields = [
      "trade_name", "type_of_firm", "city", "state", "pin_code",
      , "proprietor_name", "proprietor_email", "proprietor_mobile", "pan",
      "contact_person", "contact_person_email", "contact_person_mobile",
      "bank_name", "ifsc_code", "bank_account_number","cheque_number", "cheque_issued_name"
    ];
  
    let hasError = false;
    let updatedValues = { ...formValues };
  
    requiredFields.forEach(key => {
      if (!updatedValues[key]?.value|| (key === "pin_code" && updatedValues[key].value.length < 6)) {
        updatedValues[key] = { ...updatedValues[key], error: true };
        hasError = true;
      } else {
        updatedValues[key] = { ...updatedValues[key], error: false };
      }
    });
  
    setFormValues(updatedValues); 
  
    if (hasError) {
      console.log("cannot submit, fill mandatory")
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Please Fill All The Required Fields", {
          className: "small-toast"
        });
      }
      
      setIsActive(false);
      return;
    }

     let filteredValues= filterEmptyValues(formValues)
    
        const requiredFields2 = [
          { key: 'bp_grouping', label: 'Bp Grouping' },
          { key: 'search_term_1', label: 'Search Term 1' },
          { key: 'language', label: 'Language' },
          // { key: 'telephone', label: 'Telephone' },
          { key: 'reconciliation_account', label: 'Reconciliation Account' },
          { key: 'company_code', label: 'Company Code' },
          { key: 'payment_terms', label: 'Payment Terms' },
          { key: 'payment_methods', label: 'Payment Methods' },
          { key: 'purchase_organization', label: 'Purchase Organization' },
          { key: 'order_currency', label: 'Order Currency' },
          // Add more if you want to enforce others
        ];
        
        const missingFields = requiredFields2.filter(field => {
          const value = filteredValues[field.key]?.value;
          return Array.isArray(value) ? value.length === 0 : !value?.trim();
        });
        
        if (missingFields.length > 0) {
          const fieldNames = missingFields.map(field => field.label).join(', ');
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(`Please fill the following required fields: ${fieldNames}`, {
              className: 'small-toast'
            });
          }
          setIsActive(false)
          return;
        }
  
    try {
      setIsFormSubmiteed(true);
      console.log("here is the final form>> ", updatedValues);
      localStorage.setItem("filledForm", JSON.stringify(updatedValues));
      localStorage.setItem("filledForm2", JSON.stringify(updatedValues));
  
      const response = await updateVendorMDM(updatedValues);
      const res = response.data;
      console.log("the response from submit is >> ", res);
  
      if (res.status) {
        console.log("Submitted successfully>> ", res);
        setIsActive(false);
        setOpenComment(true);
      } else {
        console.log("could not submit>> ", res);
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Could not submit form", {
            className: "small-toast"
          });
        }
        setIsActive(false);
      }
    } catch (err) {
      console.log("Error registering vendor>> ", err);
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Error Submitting Form", {
          className: "small-toast"
        });
      }
      setIsActive(false);
    }
  };

  function capitalizeInitials(str) {
    return str
      .split(/(\s+)/) // this keeps the spaces too
      .map(word => {
        return word.trim() ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word;
      })
      .join('');
  }


  const finishApproval=async()=>{
      setIsActive(true)
            const body={
              reference_id: formValues.reference_id.value,
              approved_by: userID,
            }
            console.log("approval body>> ", body)
            try{
              const response= await syncVendorMDM(body);
              const res= response.data;
              if(res.status){
    
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.success(res.message,{
                    className:"small-toast"
                  })
                }
                setIsActive(false)
                setOpenComment(false)
                navigate("/vendors-list")
  
              }else{
                console.log("why not approve>> ", res);
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.warning(res.message,{
                    className:"small-toast"
                  })
                }
                setIsActive(false)
              }
            }catch(err){
              console.log("Error in approving>> ", err)
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error(err.message,{
                  className:"small-toast"
                })
              }
              setIsActive(false)
            }
    
          }
  

    return(
        <DashboardLayout>
        <DashboardNavbar/>

      <SimpleBackdrop openLoader={isActive} />
      <ToastContainer/>
     <Grid>
      

        
        <SoftBox className="bp formBG">
          <form noValidate onSubmit={handleSubmitForm}>
         <SoftBox py={3} className="customerblock">
           <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                   <SoftTypography variant="h5" id="form_heading textUppercase">General Data</SoftTypography>

                   

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                       <Grid item xs={12} md={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Name*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="Trade name"
                             id="trade_name"
                             error={formValues.trade_name.error} 
                             value={formValues.trade_name.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('trade_name', wordCapital)}}
                             
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} md={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Street*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="Address"
                             id="address"
                             inputProps={{ maxLength: 60 }}
                             error={formValues.street.error}
                             value={formValues.street.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('street', wordCapital)}}
                             
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={10} md={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               House Number*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="Address"
                             id="address"
                             inputProps={{ maxLength: 10 }}
                             error={formValues.house_no.error}
                             value={formValues.house_no.value}
                             onChange={(e) => handleFormChange('house_no', e.target.value)}
                             
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} md={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Type of Firm/Company*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
  name="Type of Firm"
  id="type_of_firm"
  error={formValues.type_of_firm.error}
  value={
   [{ value: formValues.type_of_firm.value, label:titleSelected? selectedTitle: formValues.type_of_firm.value }]
  }
  onChange={(e) =>{
    setTitleSelected(true)
    setSelectedTitle(e.label)
    handleFormChange('type_of_firm', e.value)
  }}
  options={firmTypes}
/>

                         </SoftBox>
                       </Grid>
                     </Grid>
                   </SoftBox>

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              CIN (if applicable)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             error={formValues.cin.error}
                             id="cin"
                             value={formValues.cin.value}
                             onChange={(e) => handleFormChange('cin', e.target.value)}
                             size="medium"
                            
                              />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               MCA/ROC Status (for Co/LLP)
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="Mca Status"
                             id="mca_roc_status"
                             error={formValues.mca_roc_status.error}
                             value={[{value: formValues.mca_roc_status.value, label: formValues.mca_roc_status.value}]}
                             onChange={(e) => handleFormChange('mca_roc_status', e.value)}
                             options={[
                               { value: "Active", label: "Active" },
                               { value: "Strike Off", label: "Strike Off" },
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               City*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="city"
                             error={formValues.city.error}
                             value={formValues.city.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('city', wordCapital)}}
                             size="medium" />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               State*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="state"
                             id="state"
                             error={formValues.state.error}
                             value={[{value: formValues.state.value, label: stateSelected? selectedState :formValues.state.value}]}
                             onChange={(e) =>{
                              setStateSelected(true)
                              setSelectedState(e.label)
                              handleFormChange('state', e.value)
                             } }
                              options = {vendorState}
                             
                           />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Pin Code*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="pin_code"
                             inputProps={{ maxLength: 6 }}
                             error={formValues.pin_code.error}
                             value={formValues.pin_code.value}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('pin_code', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                                                          if(e.target.value.length==6){
                                                             if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.warning("Pin Code Cannot be more than 6 characters", {
                                        className: "small-toast"
                                      });
                                    }
                                                          }
                                                        }}
                             size="medium"
                              />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Website
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="website"
                             name="website"
                            //  error={formValues.website.error}
                             value={formValues.website.value}
                             onChange={(e) => handleFormChange('website', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               CIN (If MCA/ROC is Active)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput  
                             type="file"
                             disabled={formValues.mca_roc_status.value !== "Active"}
                             value={formValues.latest_co_status.value}
                             onChange={(e) => handleFormChange('latest_co_status', e.target.file)}
                             placeholder="Street"
                             id="street"
                             size="medium" />
                         </SoftBox>
                       </Grid> */}
                     </Grid>
                   </SoftBox>


                 
                   

                   

                 </SoftBox>
               </Card>
             </Grid>
           </Grid>
         </SoftBox>

         <SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     <SoftTypography variant="h5" id="form_heading">Contact Details</SoftTypography>


       <SoftBox mt={1}>
         <Grid container spacing={3}>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Proprietor Name*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="Proprieter Name"
                 id="prop_name"
                 error={formValues.proprietor_name.error}
                 value={formValues.proprietor_name.value}
                 onChange={(e) => {
                  let wordCapital= capitalizeInitials(e.target.value)
                  handleFormChange('proprietor_name', wordCapital)}}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Proprietor Email*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="prop email"
                 id="prop_email"
                 error={formValues.proprietor_email.error}
                 value={formValues.proprietor_email.value}
                 onChange={(e) => handleFormChange('proprietor_email', e.target.value)}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Proprietor Mobile No*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="prop number"
                 id="prop_number"
                 inputProps={{ maxLength: 10 }}
                 error={formValues.proprietor_mobile.error}
                 value={formValues.proprietor_mobile.value}
                 onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                  handleFormChange('proprietor_mobile', onlyNumbers);
                }}
                onKeyDown={(e)=>{
                                              if(e.target.value.length==10){
                                                 if (!toast.isActive(toastId.current)) {
                          toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
                            className: "small-toast"
                          });
                        }
                                              }
                                            }}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Contact Person Name*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="contact name"
                 id="contact_person_name"
                //  defaultValue={formValues.contact_person}
                 value={formValues.contact_person.value}
                 error={formValues.contact_person.error}
                 onChange={(e) => {
                  let wordCapital= capitalizeInitials(e.target.value)
                  handleFormChange('contact_person', wordCapital)}}
               />
             </SoftBox>
           </Grid>

           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Contact Person Email*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="contact person number"
                 id="contact_person_number"
                //  defaultValue={formValues.contact_person_email}
                 value={formValues.contact_person_email.value}
                 error={formValues.contact_person_email.error}
                 onChange={(e) => handleFormChange('contact_person_email', e.target.value)}
               />
             </SoftBox>
           </Grid>

           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Contact Person Mobile No*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="contact person number"
                 id="contact_person_number"
                 inputProps={{ maxLength: 10 }}
                //  defaultValue={formValues.contact_person_mobile}
                 value={formValues.contact_person_mobile.value}
                 error={formValues.contact_person_mobile.error}
                 onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                  handleFormChange('contact_person_mobile', onlyNumbers);
                }}
                onKeyDown={(e)=>{
                                              if(e.target.value.length==10){
                                                 if (!toast.isActive(toastId.current)) {
                          toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
                            className: "small-toast"
                          });
                        }
                                              }
                                            }}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Contact Person Telephone
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="contact_telephone"
                 id="contact_telephone"
                 inputProps={{ maxLength: 11 }}
                //  defaultValue={formValues.contact_person_mobile}
                 value={formValues.contact_telephone.value}
                 error={formValues.contact_telephone.error}
                 onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                  handleFormChange('contact_telephone', onlyNumbers);
                }}
                onKeyDown={(e)=>{
                                              if(e.target.value.length==11){
                                                 if (!toast.isActive(toastId.current)) {
                          toastId.current = toast.warning("Telephone No Cannot be more than 11 digits", {
                            className: "small-toast"
                          });
                        }
                                              }
                                            }}
               />
             </SoftBox>
           </Grid>

         </Grid>
       </SoftBox>

     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

         <SoftBox py={3} className="customerblock">
           <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                   <SoftTypography variant="h5" id="form_heading">Business Data</SoftTypography>

                   
<Grid container spacing={3} alignItems="center">
 {/* <Grid item xs={12} sm={4}>
   <SoftBox mb={2}>
     <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
       <SoftTypography component="label" variant="caption" fontWeight="bold" >
         Nature of Business*
       </SoftTypography>
     </SoftBox>
     <Select
       isMulti
       name="nature_of_business"
       id="nature_of_business"
       error={formValues.nature_of_business.error}
       // value={formValues.nature_of_business.value}
       onChange={(selectedOptions) => handleFormChange("nature_of_business", selectedOptions)}
       options={[
         { value: "Capital Goods", label: "Capital Goods" },
         { value: "Manufacturing", label: "Manufacturing" },
         { value: "Trading", label: "Trading" },
         { value: "Exporter", label: "Exporter" },
         { value: "Service", label: "Service" },
         { value: "CSR", label: "CSR" },
         { value: "OTPY", label: "OTPY" },
       ]}
       styles={{
         control: (provided) => ({
           ...provided,
           minHeight: "34px",
           fontSize: "9px",
         }),
         multiValue: (provided) => ({
           ...provided,
           fontSize: "10px",
           padding: "2px",
         }),
         placeholder: (provided) => ({
           ...provided,
           fontSize: "12px",
         }),
         dropdownIndicator: (provided) => ({
           ...provided,
           padding: "4px",
         }),
       }}
     />
   </SoftBox>
 </Grid> */}

 {/* <Grid item xs={12} sm={4}>
   <SoftBox mb={2}>
     <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
       <SoftTypography component="label" variant="caption" fontWeight="bold" >
         Business Category
       </SoftTypography>
     </SoftBox>
     <Select
       isMulti
       name="business_category"
       id="business_category"
       error={formValues.business_category.error}
       // value={formvalues.business}
       onChange={(selectedOptions) => handleFormChange("business_category", selectedOptions)}
       options={[
         { value: "Raw Mat", label: "Raw Mat" },
         { value: "Packaging Mat", label: "Packaging Mat" },
         { value: "Engg Store", label: "Engg Store" },
         { value: "Fuel", label: "Fuel" },
         { value: "Transporter", label: "Transporter" },
         { value: "Contractor", label: "Contractor" },
         { value: "Oth Services", label: "Oth Services" },
         { value: "Capital", label: "Capital" },
         { value: "Adv & Sales Prom", label: "Adv & Sales Prom" },
       ]}
       styles={{
         control: (provided) => ({
           ...provided,
           minHeight: "34px",
           fontSize: "9px",
         }),
         multiValue: (provided) => ({
           ...provided,
           fontSize: "10px",
           padding: "2px",
         }),
         placeholder: (provided) => ({
           ...provided,
           fontSize: "12px",
         }),
         dropdownIndicator: (provided) => ({
           ...provided,
           padding: "4px",
         }),
       }}
     />
   </SoftBox>
 </Grid> */}





{formValues.msme_registration_no.value!=='' &&

                   
                     <>
                     <Grid item xs={12} sm={4}>
   <SoftBox mb={2}>
     <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
       <SoftTypography component="label" variant="caption" fontWeight="bold" >
         MSME Registration Status.
       </SoftTypography>
     </SoftBox>
     <SoftSelect
                             name="msme_status"
                             id="msme_status"
                             className="formstyle"
                            //  error={formValues.msme_registration_status.error}
                             value={[{value: formValues.msme_registration_status.value, label: formValues.msme_registration_status.value}]}
                             onChange={(e) => handleFormChange('msme_registration_status', e.value)}
                             options={[
                               { value: "Registered", label: "Registered" },
                               { value: "Unregistered", label: "Unregistered" },
                             ]}
                           />
   </SoftBox>
                      </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
    <SoftTypography
      component="label"
      variant="caption"
      fontWeight="bold"
    >
      MSME Registration no.
    </SoftTypography>
  </SoftBox>
  <SoftInput
    name="msme_no"
    id="msme_no"
    className="formstyle"
    value={
      formValues.msme_registration_no.value.startsWith("UDYAM-")
        ? formValues.msme_registration_no.value
        : "UDYAM-" + formValues.msme_registration_no.value
    }
    error={formValues.msme_registration_no.error}
    type="text"
    onChange={(e) => {
      let input = e.target.value;

      // If user tries to delete or type before the prefix, prevent it
      if (!input.startsWith("UDYAM-")) {
        let pre= "UDYAM-"
        input = "UDYAM-" + input.replace(new RegExp(`^${pre.replace('-', '\\-')}*`), '');
      }

      handleFormChange("msme_registration_no", input);
    }}
  />
</SoftBox>

                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              MSME Category
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="msme_category"
                             id="msme_category"
                            //  error={formValues.msme_category.error}
                             value={[{value: formValues.msme_category.value, label: formValues.msme_category.value}]}
                             onChange={(e) => handleFormChange('msme_category', e.value)}
                             options={[
                               { value: "Macro", label: "Macro" },
                               { value: "Small", label: "Small" },
                               { value: "Medium", label: "Medium" },
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              MSME Type
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="msme_type"
                             id="msme_type"
                            //  error={formValues.msme_type.error}
                             value={[{value: formValues.msme_type.value, label: formValues.msme_type.value}]}
                             onChange={(e) => handleFormChange('msme_type', e.value)}
                             options={[
                               { value: "A", label: "A" },
                               { value: "B", label: "B" },
                               { value: "C", label: "C" },
                               { value: "D", label: "D" },
                               { value: "E", label: "E" },
                               { value: "F", label: "F" },
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                      
                     </>
                  
}
{formValues.fssai_regn_no.value!=='' &&
                   <>
                    
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               FSSAI Registration Status.
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="fssai_status"
                             id="fssai_status"
                            //  error={formValues.fssai_registration_status.error}
                             value={[{value: formValues.fssai_registration_status.value, label: formValues.fssai_registration_status.value}]}
                             // value={formValues.fssi_registration_status.value}
                             onChange={(e) => handleFormChange('fssai_registration_status', e.value)}
                             options={[
                               { value: "Registered", label: "Registered" },
                               { value: "Un-registered", label: "Un-registered" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              FSSAI Regn No
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="fssai_reg"
                             id="fssai_reg"
                            //  error={formValues.fssai_regn_no.error}
                             value={formValues.fssai_regn_no.value}
                             onChange={(e) => handleFormChange('fssai_regn_no', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              FSSAI Valid Till
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="date"
                             name="fssai_valid"
                             id="fssai_valid"
                            //  error={formValues.fssai_valid_till.error}
                             value={formatDate(formValues.fssai_valid_till.value)}
                             onChange={(e) => {
                              const dateObj = new Date(e.target.value);
                              const day = String(dateObj.getDate()).padStart(2, '0');
                              const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                              const year = dateObj.getFullYear();
                              const formattedDate = `${year}${month}${day}`;
                              console.log("here is formattedDate>> ", formattedDate)  
                              handleFormChange('fssai_valid_till', formattedDate);
                            }}
                           />
                         </SoftBox>
                       </Grid>

                       
                      
                     
                   </>
}
                   <>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GSTIN No.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="gstn"
                             id="Gstn"
                             inputProps={{maxLength:15}}
                             error={formValues.gstn.error} 
                             value={formValues.gstn.value}
                              onChange={(e) => {
                                                           const gstn = e.target.value.trim();
                                                         
                                                           if (gstn === "") {
                                                            setPanGSTError2(false)
                                                             setFormValues((prev) => ({
                                                               ...prev,
                                                               gstn: { ...prev.gstn, value: gstn, error: false },
                                                               pan: { ...prev.pan, value: "", error: false },
                                                             }));
                                                             return;
                                                           }
                                                         
                                                           const gstnRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
                                                         
                                                           if (gstnRegex.test(gstn)) {
                                                             const panFromGstn = gstn.substring(2, 12);
                                                             setFormValues((prev) => ({
                                                               ...prev,
                                                               gstn: { ...prev.gstn, value: gstn, error: false },
                                                               pan: { ...prev.pan, value: panFromGstn, error: false },
                                                             }));
                                                             setPanGSTError2(false)
                                                           } else {
                                                             if (!toast.isActive(toastId.current)) {
                                                               toastId.current = toast.warning("Please Fill a valid GSTIN number", {
                                                                 className: "small-toast"
                                                               });
                                                             }
                                                             setFormValues((prev) => ({
                                                               ...prev,
                                                               gstn: { ...prev.gstn, value: gstn, error: true },
                                                               pan: { ...prev.pan, value: "", error: false },
                                                             }));
                                                             setPanGSTError2(true)
                                                           }
                                                         }}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              PAN*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="pan"
                             id="pan"
                             inputProps={{maxLength:10}}
                             error={formValues.pan.error}
                             value={formValues.pan.value}
                              onChange={(e) => {
                                                           const pan = e.target.value.trim().toUpperCase(); // PAN is always uppercase
                                                           const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                                                         
                                                           if (pan === "") {
                                                             setFormValues((prev) => ({
                                                               ...prev,
                                                               pan: { ...prev.pan, value: pan, error: false },
                                                             }));
                                                             return;
                                                           }
                                                         
                                                           if (panRegex.test(pan)) {
                                                             setFormValues((prev) => ({
                                                               ...prev,
                                                               pan: { ...prev.pan, value: pan, error: false },
                                                             }));
                                                             setPanGSTError(false)
                                                           } else {
                                                             setFormValues((prev) => ({
                                                               ...prev,
                                                               pan: { ...prev.pan, value: pan, error: true },
                                                             }));
                                                         
                                                             if (!toast.isActive(toastId.current)) {
                                                               toastId.current = toast.warning("Please enter a valid PAN number", {
                                                                 className: "small-toast",
                                                               });
                                                             }
                                                             setPanGSTError(true)
                                                           }
                                                         }}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              TAN
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tan"
                             id="tan"
                             error={formValues.tan.error}
                             value={formValues.tan.value}
                             onChange={(e) => handleFormChange('tan', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                   </>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Status of filing ITR of last 2 yrs.
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="itr_filing"
                             id="itr_filing"
                             error={formValues.itr_filing_status.error}
                             // value={formValues.itr_filing_status.value}
                             value={[{value: formValues.itr_filing_status.value, label: formValues.itr_filing_status.value}]}
                             onChange={(e) => handleFormChange('itr_filing_status', e.value=="Select"?"":e.value)}
                             options={[
                               { value: "Select", label: "Select" },
                               { value: "Filed", label: "Filed" },
                               { value: "Not Filed", label: "Not Filed" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              PAN linked with Aadhaar
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="pan_linked_aadhaar"
                             id="pan_linked_aadhaar"
                             error={formValues.pan_linked_aadhaar.error}
                             value={[{value: formValues.pan_linked_aadhaar.value, label: formValues.pan_linked_aadhaar.value}]}
                             onChange={(e) => handleFormChange('pan_linked_aadhaar', e.value="Select"?"":e.value)}
                             options={[
                               { value: "Select", label: "Select" },
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              TDS Exemption/Lower Deduction
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="tds_ememption"
                             id="tds_exemption"
                             error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             options={[
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid> */}
                  
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               If Yes, then please attach TDS Exemption/Lower Deduction Certificate.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="file"
                             id="tds_doc"
                             disabled={formValues.tds_exemption.value !== "Yes"}
                             error={formValues.tds_doc.error}
                             value={formValues.tds_doc.value}
                             onChange={(e) => handleFormChange('tds_doc', e.target.file)}
                           />
                         </SoftBox>
                       </Grid> */}
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Nature of Service for TDS
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_nature"
                             id="td_nature"
                             error={formValues.tds_nature_of_service.error}
                             value={formValues.tds_nature_of_service.value}
                             onChange={(e) => handleFormChange('tds_nature_of_service', e.target.value)}
                           />
                         </SoftBox>
                       </Grid> */}
                       
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              TDS to be Deducted u/s
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_section"
                             id="tds_section"
                             error={formValues.tds_section.error}
                             value={formValues.tds_section.value}
                             onChange={(e) => handleFormChange('tds_section', e.target.value)}
                           />
                         </SoftBox>
                       </Grid> */}

                  
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GST Turnover of Prev Yr (Lakhs).
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="gst_turnover"
                             error={formValues.gst_turnover_prev_yr.error}
                             value={formValues.gst_turnover_prev_yr.value}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('gst_turnover_prev_yr', onlyNumbers);
                            }}
                           />
                         </SoftBox>
                       </Grid>
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Prev Yr
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="prev_yr"
                             id="prev_yr"
                             error={formValues.prev_yr.error}
                             value={formValues.prev_yr.value}
                             onChange={(e) => handleFormChange('prev_yr', e.target.value)}
                           />
                         </SoftBox>
                       </Grid> */}
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              e-Invoice Applicable
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="e-invoice"
                             id="e-invoice"
                             value={[{value: formValues.e_invoice_applicable.value, label: formValues.e_invoice_applicable.value}]}
                             error={formValues.e_invoice_applicable.error}
                             onChange={(e) => handleFormChange('e_invoice_applicable', e.value=="Select"?"":e.value)}
                             options={[
                               { value: "Select", label: "Select" },
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>


                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Bank Name*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_name"
                             error={formValues.bank_name.error}
                             value={formValues.bank_name.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('bank_name', wordCapital)}}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              IFSC Code*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="ifsc_code"
                             id="ifsc_code"
                             error={formValues.ifsc_code.error}
                             value={formValues.ifsc_code.value}
                             onChange={(e) => handleFormChange('ifsc_code', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Bank Account Number*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="incoterms2"
                             id="incoterms2"
                             inputProps={{maxLength:20}}
                             error={formValues.bank_account_number.error}
                             value={formValues.bank_account_number.value}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('bank_account_number', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                                                          if(e.target.value.length==20){
                                                             if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.warning("Account No Cannot be more than 20 digits", {
                                        className: "small-toast"
                                      });
                                    }
                                                          }
                                                        }}
                           />
                         </SoftBox>
                       </Grid>
                       
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Cheque Number*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="incoterms2"
                             id="incoterms2"
                             error={formValues.cheque_number.error}
                             value={formValues.cheque_number.value}
                             onChange={(e) => handleFormChange('cheque_number', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>

                  
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Cheque to be Issued in name of*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             size="medium"
                             name="cheque_issued_name"
                             id="cheque_issued_name"
                             error={formValues.cheque_issued_name.error}
                             value={formValues.cheque_issued_name.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('cheque_issued_name', wordCapital)}}
                             
                           />
                         </SoftBox>
                       </Grid>

                       {/* <Grid item xs={12} sm={4}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GSTN Document*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="file"
                             size="medium"
                             name="gstn_document"
                             id="gstn_document"
                             error={formValues.gstn_document.error}
                             // value={formValues.gstn_document.value}
                             onChange={(e) => handleFormChange('gstn_document', e.target.file)}
                           />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               PAN Document*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="file"
                             name="pan"
                             id="pan"
                             error={formValues.pan_document.error}
                             value={formValues.pan_document.value}
                             onChange={(e) => handleFormChange('pan_document', e.target.file)}
                             placeholder="GSTN"
                             size="medium"
                             // inputProps={{ maxLength: "15" }}
                           />
                         </SoftBox>
                       </Grid> */}
                    </Grid> 
                 </SoftBox>
               </Card>
             </Grid>
           </Grid>
         </SoftBox>

         <Grid container alignItems="center" spacing={3}>
                             <Grid item xs={12} sm={4}>
            
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                  Nature of Business
                </SoftTypography>
              </SoftBox>
         
              
              <Select
           isMulti
           menuPlacement="auto"
           menuPortalTarget={document.body} // Ensures it renders outside the dialog
           menuPosition="fixed" // Prevents it from being cut off
           name="nature_of_business"
           id="nature_of_business"
           value={
            formValues.nature_of_business.value.length > 0
              ? formValues.nature_of_business.value.map((val) => ({ value: val, label: val }))
              : null
          }
           onChange={(selectedOptions) => handleFormChange("nature_of_business", selectedOptions)}
           options={[
             { value: "Capital Goods", label: "Capital Goods" },
             { value: "Manufacturing", label: "Manufacturing" },
             { value: "Trading", label: "Trading" },
             { value: "Exporter", label: "Exporter" },
             { value: "Service", label: "Service" },
             { value: "CSR", label: "CSR" },
             { value: "OTPY", label: "OTPY" },
           ]}
           styles={{
             control: (provided) => ({
               ...provided,
               minHeight: "34px",
               fontSize: "9px",
             }),
             multiValue: (provided) => ({
               ...provided,
               fontSize: "10px",
               padding: "2px",
             }),
             placeholder: (provided) => ({
               ...provided,
               fontSize: "12px",
             }),
             dropdownIndicator: (provided) => ({
               ...provided,
               padding: "4px",
             }),
             menu: (provided) => ({
               ...provided,
               zIndex: 9999, 
               position: "absolute",
             }),
             menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is always visible
           }}
         />
         
            
          </Grid>
          <Grid item xs={12} sm={4}>
            
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                  Business Category
                </SoftTypography>
              </SoftBox>
              <Select
                isMulti
                name="business_category"
                id="business_category"
                menuPlacement="auto"
                menuPortalTarget={document.body} // Ensures it renders outside the dialog
                menuPosition="fixed" // Prevents it from being cut off
                value={
                  formValues.business_category.value.length > 0
                    ? formValues.business_category.value.map((val) => ({ value: val, label: val }))
                    : null
                }
                error={formValues.business_category.error}
                // value={formvalues.business}
                onChange={(selectedOptions) => handleFormChange("business_category", selectedOptions)}
                options={[
                  { value: "Raw Mat", label: "Raw Mat" },
                  { value: "Packaging Mat", label: "Packaging Mat" },
                  { value: "Engg Store", label: "Engg Store" },
                  { value: "Fuel", label: "Fuel" },
                  { value: "Transporter", label: "Transporter" },
                  { value: "Contractor", label: "Contractor" },
                  { value: "Oth Services", label: "Oth Services" },
                  { value: "Capital", label: "Capital" },
                  { value: "Adv & Sales Prom", label: "Adv & Sales Prom" },
                ]}
                styles={{
                 control: (provided) => ({
                   ...provided,
                   minHeight: "34px",
                   fontSize: "9px",
                 }),
                 multiValue: (provided) => ({
                   ...provided,
                   fontSize: "10px",
                   padding: "2px",
                 }),
                 placeholder: (provided) => ({
                   ...provided,
                   fontSize: "12px",
                 }),
                 dropdownIndicator: (provided) => ({
                   ...provided,
                   padding: "4px",
                 }),
                 menu: (provided) => ({
                   ...provided,
                   zIndex: 9999, 
                   position: "absolute",
                 }),
                 menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is always visible
               }}
              />
            
          </Grid>
                             </Grid>

                             <Grid container alignItems="center" spacing={2}>
                                             <Grid item xs={12} sm={4}>
                                                      <SoftBox mb={3} id="name3">
                                                        <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                          <SoftTypography
                                                            component="label"
                                                            variant="caption"
                                                            fontWeight="bold"
                                                            textTransform="capitalize"
                                                          >
                                                           TDS Exemption/Lower Deduction
                                                          </SoftTypography>
                                                        </SoftBox>
                                                        <SoftSelect
                                                          name="tds_ememption"
                                                          id="tds_exemption"
                                                         //  error={formValues.tds_exemption.error}
                                                          value={[{value:formValues.tds_exemption.value,label:formValues.tds_exemption.value}]}
                                                          onChange={(e) => handleFormChange('tds_exemption', e.value)}
                                                          options={[
                                                            { value: "Yes", label: "Yes" },
                                                            { value: "No", label: "No" },
                                                            
                                                          ]}
                                                        />
                                                      </SoftBox>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                    <SoftBox mb={3}>
                                                        <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                          <SoftTypography
                                                            component="label"
                                                            variant="caption"
                                                            fontWeight="bold"
                                                            textTransform="capitalize"
                                                          >
                                                           Nature of Service for TDS
                                                          </SoftTypography>
                                                        </SoftBox>
                                                        <SoftInput
                                                        type="text"
                                                          name="tds_nature"
                                                          id="td_nature"
                                                         //  error={formValues.tds_nature_of_service.error}
                                                          value={formValues.tds_nature_of_service.value}
                                                          onChange={(e) => handleFormChange('tds_nature_of_service', e.target.value)}
                                                        />
                                                      </SoftBox>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                      <SoftBox mb={3} id="name3">
                                                        <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                          <SoftTypography
                                                            component="label"
                                                            variant="caption"
                                                            fontWeight="bold"
                                                            textTransform="capitalize"
                                                          >
                                                           TDS to be Deducted u/s
                                                          </SoftTypography>
                                                        </SoftBox>
                                                        <SoftInput
                                                        type="text"
                                                          name="tds_section"
                                                          id="tds_section"
                                                         //  error={formValues.tds_section.error}
                                                          value={formValues.tds_section.value}
                                                          onChange={(e) => handleFormChange('tds_section', e.target.value)}
                                                        />
                                                      </SoftBox>
                                                    </Grid>
                                             </Grid>

<SoftBox py={2} style={{ overflowX: "auto" }}>
                <Grid container alignItems="center" spacing={0.5}>
                <Grid item xs={12}>
                <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>Basic Data</SoftTypography>
  </Grid>
                <Grid item xs={12} sm={4}>
   
   <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
     <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
       Nature of Business*
     </SoftTypography>
   </SoftBox>

   
   <Select
isMulti
menuPlacement="auto"
menuPortalTarget={document.body} // Ensures it renders outside the dialog
menuPosition="fixed" // Prevents it from being cut off
name="nature_of_business"
id="nature_of_business"
value={
  formValues.nature_of_business.value.length > 0
    ? formValues.nature_of_business.value.map((val) => ({ value: val, label: val }))
    : null
}
onChange={(selectedOptions) => handleFormChange("nature_of_business", selectedOptions)}
options={[
  { value: "Capital Goods", label: "Capital Goods" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Trading", label: "Trading" },
  { value: "Exporter", label: "Exporter" },
  { value: "Service", label: "Service" },
  { value: "CSR", label: "CSR" },
  { value: "OTPY", label: "OTPY" },
]}
styles={{
  control: (provided) => ({
    ...provided,
    minHeight: "34px",
    fontSize: "9px",
  }),
  multiValue: (provided) => ({
    ...provided,
    fontSize: "10px",
    padding: "2px",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "12px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, 
    position: "absolute",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is always visible
}}
/>

 
</Grid>
<Grid item xs={12} sm={4}>
 
   <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
     <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
       Business Category*
     </SoftTypography>
   </SoftBox>
   <Select
    isMulti
    name="business_category"
    id="business_category"
    menuPlacement="auto"
    menuPortalTarget={document.body} // Ensures it renders outside the dialog
    menuPosition="fixed" // Prevents it from being cut off
    value={
      formValues.business_category.value.length > 0
        ? formValues.business_category.value.map((val) => ({ value: val, label: val }))
        : null
    }
    error={formValues.business_category.error}
     // value={formvalues.business}
     onChange={(selectedOptions) => handleFormChange("business_category", selectedOptions)}
     options={[
       { value: "Raw Mat", label: "Raw Mat" },
       { value: "Packaging Mat", label: "Packaging Mat" },
       { value: "Engg Store", label: "Engg Store" },
       { value: "Fuel", label: "Fuel" },
       { value: "Transporter", label: "Transporter" },
       { value: "Contractor", label: "Contractor" },
       { value: "Oth Services", label: "Oth Services" },
       { value: "Capital", label: "Capital" },
       { value: "Adv & Sales Prom", label: "Adv & Sales Prom" },
     ]}
     styles={{
      control: (provided) => ({
        ...provided,
        minHeight: "34px",
        fontSize: "9px",
      }),
      multiValue: (provided) => ({
        ...provided,
        fontSize: "10px",
        padding: "2px",
      }),
      placeholder: (provided) => ({
        ...provided,
        fontSize: "12px",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: "4px",
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999, 
        position: "absolute",
      }),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is always visible
    }}
   />
 
</Grid>

<Grid item xs={12} sm={4}>
                        
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              TDS Exemption/Lower Deduction
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="tds_ememption"
                             id="tds_exemption"
                            //  error={formValues.tds_exemption.error}
                            value={[
                              {value: formValues.tds_exemption.value,label: formValues.tds_exemption.value}
                            ]}
                             onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             options={[
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                        
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Nature of Service for TDS
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_nature"
                             id="td_nature"
                            //  error={formValues.tds_nature_of_service.error}
                             value={formValues.tds_nature_of_service.value}
                             onChange={(e) => handleFormChange('tds_nature_of_service', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              TDS to be Deducted u/s
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_section"
                             id="tds_section"
                            //  error={formValues.tds_section.error}
                             value={formValues.tds_section.value}
                             onChange={(e) => handleFormChange('tds_section', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Search Term 1
                             </SoftTypography>
                           </SoftBox>
                         
                            
                           <SoftInput
                             name="search_term_1"
                             id="search_term_1"
                             value={ formValues.search_term_1.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('search_term_1', e.target.value)}
                             
                           />
                           
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Search Term 2
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="search_term_2"
                             id="search_term_2"
                             value={ formValues.search_term_2.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('search_term_2', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>
                <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              BP Grouping*
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('bpgrp','bp_grouping')}>
                            
                           <SoftInput
                             name="bp_grouping"
                             id="bp_grouping"
                             value={formValues.bp_grouping.value}
                             readOnly
                             style={{cursor:'pointer'}}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Language
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="language"
                             id="language"
                             disabled
                            //  error={formValues.tds_nature_of_service.error}
                             value={formValues.language.value}
                             onChange={(e) => handleFormChange('language', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Telephone
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="telephone"
                             id="telephone"
                            //  error={formValues.tds_section.error}
                             value={ formValues.telephone.value}
                             onChange={(e) => handleFormChange('telephone', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              District
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="district"
                             id="district"
                             value={formValues.district.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('district', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Po Box
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="po_box"
                             id="po_box"
                             value={ formValues.po_box.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('po_box', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Region
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('region','region')}>
                            
                           <SoftInput
                             name="region"
                             id="region"
                             readOnly
                             value={ formValues.region.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12}>
                       <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>Company Code Data</SoftTypography>
  </Grid>

  <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Company Code*
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('compcode','company_code')}>
                            
                           <SoftInput
                             name="region"
                             id="region"
                             readOnly
                             value={ formValues.company_code.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              CST No.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="cst_no"
                             id="cst_no"
                            //  error={formValues.tds_section.error}
                             value={formValues.cst_no.value}
                             onChange={(e) => handleFormChange('cst_no', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              LST No.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="lst_no"
                             id="lst_no"
                            //  error={formValues.tds_section.error}
                             value={formValues.lst_no.value}
                             onChange={(e) => handleFormChange('lst_no', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Contact Allowance
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <Checkbox name="contact_allowance"
                             id="contact_allowance"
                                                  checked={formValues.contact_allowance.value=='1'}
                                                  onChange={(e) => handleFormChange('contact_allowance', e.target.checked? '1':'')}
                                                  style={{ marginLeft: '8px' }}
                                                />
                          
                         </SoftBox>
                       </Grid>
                    
                       
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              C/O Name
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="co_name"
                             id="co_name"
                             value={formValues.co_name.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('co_name', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Reconciliation Account*.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('reconacc', 'reconciliation_account')}>
                            
                            <SoftInput
                              name="recon_account"
                              id="recon_account"
                              readOnly
                              value={formValues.reconciliation_account.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Sort Key.
                             </SoftTypography>
                           </SoftBox>
                           <div >
                            
                            <SoftInput
                              name="sort_key"
                              id="sort_key"
                              disabled
                              value={formValues.sort_key.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Payment Terms*.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('payterms','payment_terms')}>
                            
                            <SoftInput
                              name="payment_terms"
                              id="payment_terms"
                              readOnly
                              value={formValues.payment_terms.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Payment Methods*.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('paymthd', 'payment_methods')}>
                            
                           <SoftInput
                             name="payment_methods"
                             id="payment_methods"
                             readOnly
                             value={formValues.payment_methods.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Bank Key.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('bankkey', 'bank_key')}>
                            
                            <SoftInput
                              name="bank_key"
                              id="bank_key"
                              readOnly
                              value={formValues.bank_key.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Account Holder Name
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="account_holder_name"
                             id="account_holder_name"
                             value={ formValues.account_holder_name.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('account_holder_name', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              ABC Indicator
                             </SoftTypography>
                           </SoftBox>

                           <SoftSelect
                                                        name="abc_indicator"
                                                        id="abc_indicator"
                                                       //  error={formValues.msme_type.error}
                                                        value={[{value: formValues.abc_indicator.value, label: formValues.abc_indicator.value}]}
                                                        onChange={(e) => handleFormChange('abc_indicator', e.value)}
                                                        options={[
                                                          { value: "A", label: "A" },
                                                          { value: "B", label: "B" },
                                                          { value: "C", label: "C" },
                                                          { value: "D", label: "D" },
                                                          { value: "E", label: "E" },
                                                          { value: "F", label: "F" },
                                                        ]}
                                                      />
                          
                         </SoftBox>
                       </Grid>

                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Withholding Tax Type.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type')}>
                            
                           <SoftInput
                             name="witholding_tax"
                             id="witholding_tax"
                             value={formValues.withholding_tax_type.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Withholding Tax Code.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('witall', 'withholding_tax_code')}></div>
                           <SoftInput
                           type="text"
                             name="withholding_tax_code"
                             id="withholding_tax_code"
                            
                            //  error={formValues.tds_section.error}
                             value={formValues.withholding_tax_code.value}
                            //  onChange={(e) => handleFormChange('withholding_tax_code', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Withholding Subject
                             </SoftTypography>
                           </SoftBox>
                       
                            <Checkbox name="withholding_subject"
                             id="withholding_subject"
                                                  checked={formValues.withholding_subject.value=='X'}
                                                  onChange={(e) => handleFormChange('withholding_subject', e.target.checked? 'X':'')}
                                                />
                          
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Recipient Type.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('recpttyp', 'recipient_type')}>
                            
                           <SoftInput
                             name="recipient_type"
                             id="recipient_type"
                             value={formValues.recipient_type.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid> */}

                       <Table   bordered hover size="sm" style={{ fontSize: 12 , padding:3}}>
                       <thead>
                       <tr style={{color : "white",backgroundColor: "#3498db"}}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Type</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Code</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Subject</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Recipient Type</th>
                      </tr>
                       </thead>
                       <tbody>
                       <tr className="border">
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type')}>
                            
                            <SoftInput
                              name="witholding_tax"
                              id="witholding_tax"
                              readOnly
                              value={formValues.withholding_tax_type.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type')}>
                            
                            <SoftInput
                              name="witholding_code"
                              id="witholding_code"
                              readOnly
                              value={formValues.withholding_tax_code.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       <td className="border p-2 bg-white">
                       <div className="flex items-center justify-center">
    <Checkbox
      name="withholding_subject"
      id="withholding_subject"
      checked={formValues.withholding_subject.value == 'X'}
      onChange={(e) => handleFormChange('withholding_subject', e.target.checked ? 'X' : '')}
       sx={{ color: "#01040a" , backgroundColor: "#fff"}}
    />
  </div>
                       </td>
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('recpttyp', 'recipient_type')}>
                            
                            <SoftInput
                              name="recipient_type"
                              id="recipient_type"
                              value={formValues.recipient_type.value}
                              readOnly
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       </tr>
                       <tr className="border">
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type_2')}>
                            
                            <SoftInput
                              name="witholding_tax"
                              id="witholding_tax"
                              readOnly
                              value={formValues.withholding_tax_type_2.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type_2')}>
                            
                            <SoftInput
                              name="witholding_code"
                              id="witholding_code"
                              readOnly
                              value={formValues.withholding_tax_code_2.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       <td className="border p-2 bg-white">
  <div className="flex items-center justify-center">
    <Checkbox
      name="withholding_subject"
      id="withholding_subject"
      checked={formValues.withholding_subject_2.value == 'X'}
      onChange={(e) => handleFormChange('withholding_subject_2', e.target.checked ? 'X' : '')}
      sx={{ color: "#01040a", backgroundColor: "#fff" }}
      className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
    />
  </div>
</td>

                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('recpttyp', 'recipient_type_2')}>
                            
                            <SoftInput
                              name="recipient_type"
                              id="recipient_type"
                              value={formValues.recipient_type_2.value}
                              readOnly
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       </tr>
                       </tbody>
                       </Table>

                        <div style={{overflowX: 'auto'}}>

                       <Table   bordered hover size="sm" style={{ fontSize: 12 , padding:3 }}>
                       <thead>
                       <tr style={{color : "white",backgroundColor: "#3498db"}}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Section Code</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Number</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Rate</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exempt From</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exempt To</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Reason</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Type</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Code</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exem Threshold</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Currency</th>
                      </tr>
                       </thead>
                       <tbody>
  {formValues.tds_details.map((item, index) => (
    <tr key={index} className="border">
      {/* Section Code */}
      <td className="border p-2">
        <div className="flex justify-center">
          <SoftSelect
            name="section_code"
            id={`section_code_${index}`}
            value={[{ value: item.section_code, label: item.section_code }]}
            options={[{ value: "GR01", label: "GR01" }]}
            menuPlacement="auto"
            onChange={(e) => handleFormChange("section_code", e.value, index)}
          />
        </div>
      </td>

      {/* Exemption Number */}
      <td className="border p-2">
        <SoftInput
          type="text"
          name="exemption_number"
          id={`exemption_number_${index}`}
          className="w-full"
          value={item.exemption_number}
          onChange={(e) =>
            handleFormChange("exemption_number", e.target.value, index)
          }
        />
      </td>

      {/* Exemption Rate */}
      <td className="border p-2">
        <SoftInput
          type="number"
          name="exemption_rate"
          id={`exemption_rate_${index}`}
          className="w-full"
          value={item.exemption_rate}
          onChange={(e) =>
            handleFormChange("exemption_rate", e.target.value, index)
          }
        />
      </td>

      {/* Exemption From Date */}
      <td className="border p-2">
  <div className="flex items-center justify-center min-w-[10rem]">
    <SoftInput
      className="w-full"
      type="date"
      name="exemption_from"
      id={`exemption_from_${index}`}
      value={formatDate(item.exemption_from)}
      onChange={(e) => {
        const raw = e.target.value;
        const [year, month, day] = raw.split("-");
        const formatted = `${year}${month}${day}`;
        handleFormChange("exemption_from", formatted, index);
      }}
    />
  </div>
</td>


      {/* Exemption To Date */}
      <td className="border p-2">
  <div className="flex items-center justify-center min-w-[10rem]">
    <SoftInput
      className="w-full"
      type="date"
      name="exemption_to"
      id={`exemption_to_${index}`}
      value={formatDate(item.exemption_to)}
      onChange={(e) => {
        const raw = e.target.value;
        const [year, month, day] = raw.split("-");
        const formatted = `${year}${month}${day}`;
        handleFormChange("exemption_to", formatted, index);
      }}
    />
  </div>
</td>


      {/* Exemption Reason */}
      <td className="border p-2">
        <div
          onClick={() =>
            handleDropdownClick2("tdsrsn", "exemption_reason", index)
          }
        >
          <SoftInput
            readOnly
            name="exemption_reason"
            id={`exemption_reason_${index}`}
            value={item.exemption_reason}
            className="w-full"
          />
        </div>
      </td>

      {/* Withholding Tax Type */}
      <td className="border p-2">
        <div
          onClick={() =>
            handleDropdownClick2("tdstype", "withholding_tax_type_3", index)
          }
        >
          <SoftInput
            readOnly
            name="withholding_tax_type_3"
            id={`withholding_tax_type_3_${index}`}
            value={item.withholding_tax_type_3}
            className="w-full"
          />
        </div>
      </td>

      {/* Withholding Tax Code */}
      <td className="border p-2">
        <div
          onClick={() =>
            handleDropdownClick2("tdscode", "withholding_tax_code_3", index)
          }
        >
          <SoftInput
            readOnly
            name="withholding_tax_code_3"
            id={`withholding_tax_code_3_${index}`}
            value={item.withholding_tax_code_3}
            className="w-full"
          />
        </div>
      </td>

      {/* Threshold */}
      <td className="border p-2">
        <SoftInput
          type="number"
          name="exemp_threshold"
          id={`exemp_threshold_${index}`}
          className="w-full"
          value={item.exemp_threshold}
          onChange={(e) =>
            handleFormChange("exemp_threshold", e.target.value, index)
          }
        />
      </td>

      {/* Currency */}
      <td className="border p-2">
        <SoftInput
          type="text"
          name="currency"
          id={`currency_${index}`}
          className="w-full"
          value={item.currency}
          onChange={(e) =>
            handleFormChange("currency", e.target.value, index)
          }
        />
      </td>

      {/* Remove Button */}
      <td className="border p-2 text-center align-middle">
        {index > 0 && (
          <SoftButton onClick={() => handleRemoveRow(index)} color="error">
            ❌
          </SoftButton>
        )}
      </td>
    </tr>
  ))}
</tbody>

{/* Add Row Button in Footer */}
<tfoot>
  <tr>
    <td colSpan={11} className="p-3 text-right">
      <SoftButton onClick={handleAddRow} color="success">
        ➕ Add Row
      </SoftButton>
    </td>
  </tr>
</tfoot>


                       </Table>
                        </div>
                       
                       <Table striped  bordered hover size="sm" style={{ fontSize: 12 }}>
                       <thead>
                       <tr style={{color : "white",backgroundColor: "#3498db"}}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Tax Type</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Tax Number</th>
                      </tr>
                       </thead>
                       <tbody>
                       <tr className="border">
                            <td className="border p-2">{
                          <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               Tax Type 1
                              </SoftTypography>
                            </SoftBox>
                            <div onClick={() => handleDropdownClick('taxtype', 'tax_type')}>
                            {/* <TextField
   name="tax_type"
   id="tax_type"
   disabled
   // onChange={(e) => handleFormChange('tax_type', e.target.value)}
   InputProps={{
     startAdornment: <InputAdornment position="start">
     <Typography sx={{ fontSize: '15px' }}>IN1</Typography>
   </InputAdornment>,
   }}
   variant="outlined"
 /> */}
                            <SoftInput
                              name="tax_type"
                              id="tax_type"
                              readOnly
                              value={formValues.tax_type.value}
                              error={formValues.tax_type.error}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                            
                            />
                            </div>
                          </SoftBox>
                        </Grid>
                          }</td>
                            <td className="border p-2">{<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 1
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number"
                             id="tax_number"
                             value={ formValues.tax_number.value}
                             error={formValues.tax_number.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>}</td>
                          </tr>
                          <tr className="border">
                            <td className="border p-2">{ <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Type 2
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('taxtype', 'tax_type_2')}>
                            
                           {/* <TextField
  name="tax_type"
  id="tax_type"
  // value={selectedVendor?.gst_turnover_prev_yr
  // }
  disabled
  // onChange={(e) => handleFormChange('tax_type', e.target.value)}
  InputProps={{
    startAdornment: <InputAdornment position="start">
    <Typography sx={{ fontSize: '15px' }}>IN2</Typography>
  </InputAdornment>,
  }}
  variant="outlined"
/> */}
  <SoftInput
                             name="tax_type_2"
                             id="tax_type_2"
                             readOnly
                             value={formValues.tax_type_2.value}
                             error={formValues.tax_type_2.error}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                           
                           />
                           </div>
                         </SoftBox>
                       </Grid>}</td>
                       <td className="border p-2">{ <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 2
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number_2"
                             id="tax_number_2"
                             value={ formValues.tax_number_2.value}
                             error={formValues.tax_number_2.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number_2', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>}</td>
                          </tr>
                          <tr className="border">
                            <td className="border p-2">{<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Type 3
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('taxtype', 'tax_type_3')}>
                            
                           {/* <TextField
  name="tax_type"
  id="tax_type"
  disabled
  szie="medium"
  // onChange={(e) => handleFormChange('tax_type', e.target.value)}
  InputProps={{
    startAdornment: <InputAdornment position="start">
    <Typography sx={{ fontSize: '15px' }}>IN3</Typography>
  </InputAdornment>,
  }}
  variant="outlined"
/> */}

<SoftInput
                             name="tax_type_3"
                             id="tax_type_3"
                             readOnly
                             value={formValues.tax_type_3.value}
                             error={formValues.tax_type_3.error}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                           
                           />
                           </div>
                         </SoftBox>
                       </Grid>}</td>
                       <td className="border p-2">{<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 3
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number_3"
                             id="tax_number_3"
                             value={ formValues.tax_number_3.value}
                             error={formValues.tax_number_3.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number_3', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>}</td>
                          </tr>
                          <tr className="border">
                            <td className="border p-2">{<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Type 4
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('taxtype', 'tax_type_4')}>
                            
                           {/* <TextField
  name="tax_type"
  id="tax_type"
  disabled
  szie="medium"
  // onChange={(e) => handleFormChange('tax_type', e.target.value)}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <Typography sx={{ fontSize: '15px' }}>IN4</Typography>
      </InputAdornment>
    ),
  }}
  variant="outlined"
/> */}

<SoftInput
                             name="tax_type_4"
                             id="tax_type_4"
                             readOnly
                             value={formValues.tax_type_4.value}
                             error={formValues.tax_type_4.error}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                           
                           />
                           </div>
                         </SoftBox>
                       </Grid>}</td>
                       <td className="border p-2">{  <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 4
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number_4"
                             id="tax_number_4"
                             value={ formValues.tax_number_4.value}
                             error={formValues.tax_number_4.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number_4', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>
}</td>
                          </tr>
                       </tbody>
                       </Table>
                       
                       <Grid item xs={12}>
                       <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>Purchasing Data</SoftTypography>
  </Grid>
                      
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              GR based invoice verification
                             </SoftTypography>
                           </SoftBox>
                       
                            <Checkbox name="gr_based_invoice_verification"
                             id="gr_based_invoice_verification"
                                                  checked={formValues.gr_based_invoice_verification.value=='X'}
                                                  onChange={(e) => handleFormChange('gr_based_invoice_verification', e.target.checked? 'X':'')}
                                                  style={{ marginLeft: '8px' }}
                                                />
                          
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Service based invoice verification
                             </SoftTypography>
                           </SoftBox>
                       
                            <Checkbox name="service_based_invoice_verification"
                             id="service_based_invoice_verification"
                                                  checked={formValues.service_based_invoice_verification.value=='X'}
                                                  onChange={(e) => handleFormChange('service_based_invoice_verification', e.target.checked? 'X':'')}
                                                  style={{ marginLeft: '8px' }}
                                                />
                          
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Purchase Organization*
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('porg', 'purchase_organization')}>
                            
                           <SoftInput
                             name="witholding_tax"
                             id="witholding_tax"
                             readOnly
                             value={formValues.purchase_organization.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>

                      
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Type 5
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('taxtype', 'tax_type_5')}>
                            
                           <TextField
  name="tax_type"
  id="tax_type"
  // value={selectedVendor?.msme_registration_no
  // }
  disabled
  szie="medium"
  // onChange={(e) => handleFormChange('tax_type', e.target.value)}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <Typography sx={{ fontSize: '15px' }}>IN5</Typography>
      </InputAdornment>
    ),
  }}
  variant="outlined"
/>
                           </div>
                         </SoftBox>
                       </Grid> */}
                       
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 5
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number_5"
                             id="tax_number_5"
                             value={ formValues.tax_number_5.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number_5', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid> */}
                       

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Order Currency*.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('ordrcurr','order_currency')}>
                            
                           <SoftInput
                             name="order_currency"
                             id="order_currency"
                             readOnly
                             value={formValues.order_currency.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Schema Group Supplier
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('schema','vendor_schema')}>
                            
                           <SoftInput
                            disabled
                             name="schema"
                             id="schema"
                             value={formValues.vendor_schema.value}
                            //  error={formValues.tds_exemption.error}
                            //  value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>

                </Grid>
                </SoftBox>

         <SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     {/* <div style={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
<input 
// style={{marginTop:'10px'}}
 type="checkbox" 
 style={{ cursor: "pointer", marginTop:'10px' }} 
 checked={formValues.declaration?.value || false} 
 onChange={(e) => handleFormChange("declaration", e.target.checked)} 
/>
<SoftTypography variant="h5" id="form_heading">
 <span style={{ fontSize: "12px" }}>
   I/W<span style={{textTransform: 'lowercase'}}>e</span> <span style={{textTransform: 'lowercase'}}> certify that the above information given here in including the attachments are correct to the best of my knowledge. </span>
 </span>
</SoftTypography>
</div> */}


       {/* <SoftBox mt={1}>
         <Grid container spacing={3}>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Date*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="date"
                 name="Trade name"
                 id="trade_name"
                 error={formValues.date_of_fillup.error}
                 value={formValues.date_of_fillup.value}
                 onChange={(e) => handleFormChange('date_of_fillup', e.target.value)}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Signature (Your Full Name)*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="Address"
                 id="address"
                 error={formValues.signature.error}
                 value={formValues.signature.value}
                 onChange={(e) => handleFormChange('signature', e.target.value)}
               />
             </SoftBox>
           </Grid>
         </Grid>
       </SoftBox> */}

       {/* Submit Button */}
       <Grid container justifyContent="flex-end" mt={2}>
         <Grid item>
           <SoftButton disabled={panGSTError || panGSTError2} type="submit" variant="contained" color="primary">
             Save & Continue
           </SoftButton>
         </Grid>
       </Grid>
     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

         </form>
         </SoftBox>

         <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                                 <SimpleBackdrop openLoader={searchLoader}/>
                         <DialogTitle>Select an Option</DialogTitle>
                         <DialogContent>
         
                         <input
                   type="text"
                   placeholder="Search..."
                   value={searchTerm}
                   onChange={(e) => setSearchTerm(e.target.value)}
                   style={{
                     width: "100%",
                     padding: "5px",
                     marginBottom: "10px",
                     fontSize: "12px",
                   }}
                 />
                  <SoftButton
               onClick={() => handleFormChange(selectedField, "")}
               style={{
                 marginBottom: "10px",
                 backgroundColor: "#ccc",
                 border: "none",
                 padding: "5px 10px",
                 fontSize: "12px",
                 cursor: "pointer",
                 borderRadius: "4px"
               }}
             >
               Clear Selection
             </SoftButton>
                         <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                         <thead>
                         <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                 <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                                 <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                               </tr>
                             </thead>
                             <tbody>
                               {keySelected &&
                                 filteredData?.map((item, index) => (
                                   <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => handleFormChange(selectedField,item.value)}>
                                     <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                                     <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                                   </tr>
                                 ))}
                             </tbody>
                           </Table>
                         </DialogContent>
                       </Dialog>

                       <Dialog open={dialogOpen2} onClose={() => setDialogOpen2(false)}>
                                       <SimpleBackdrop openLoader={isActive}/>
                                       <DialogTitle>Select an Option</DialogTitle>
                                       <DialogContent>
                       
                                       <input
                                 type="text"
                                 placeholder="Search..."
                                 value={searchTerm}
                                 onChange={(e) => setSearchTerm(e.target.value)}
                                 style={{
                                   width: "100%",
                                   padding: "5px",
                                   marginBottom: "10px",
                                   fontSize: "12px",
                                 }}
                               />
                                <SoftButton
                             onClick={() => handleFormChange(selectedField, "", indexSelected)}
                             style={{
                               marginBottom: "10px",
                               backgroundColor: "#ccc",
                               border: "none",
                               padding: "5px 10px",
                               fontSize: "12px",
                               cursor: "pointer",
                               borderRadius: "4px"
                             }}
                           >
                             Clear Selection
                           </SoftButton>
                                       <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                                       <thead>
                                       <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                               <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                                               <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                             </tr>
                                           </thead>
                                           <tbody>
                                             {keySelected &&
                                               filteredData?.map((item, index) => (
                                                 <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => handleFormChange(selectedField,item.value,indexSelected)}>
                                                   <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                                                   <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                                                 </tr>
                                               ))}
                                           </tbody>
                                         </Table>
                                       </DialogContent>
                                     </Dialog>

                                       <Dialog open={openComment} onClose={()=>setOpenComment(false)} maxWidth="xs" fullWidth>
                                        <SimpleBackdrop openLoader={isActive}/>
                                                       <DialogTitle>Sync with SAP?</DialogTitle>
                                                       <DialogContent>
                                                           <SoftButton onClick={finishApproval} color="success" variant="contained" mt={1}>Sync</SoftButton>
                                                       </DialogContent>
                                                   </Dialog>
        
     </Grid>
     
      </DashboardLayout>
    )
}

export default VendorForm3